<template>
    <div style="height: 100%;">
        <el-row :gutter="20" class="container">
                <!--右边主要区-->
                <el-col :span="24" :xs="24" class="container" style="flex-direction: column;border-width: 0;padding-top: 25px;">
                    <!--右边头部搜索区-->
                    <el-form :model="queryParams.param" ref="queryForm" :inline="true" label-position="right" v-show="showSearch" label-width="110px">
                                <!-- 组织名 -->
                                <el-form-item :label="columnInfo.name.label" prop="name">
                                        <el-input v-model="queryParams.param.name" placeholder="请输入内容" size="small" clearable></el-input>
                                </el-form-item>
                                <!-- 组织代码 -->
                                <el-form-item :label="columnInfo.code.label" prop="code">
                                        <el-input v-model="queryParams.param.code" placeholder="请输入内容" size="small" clearable></el-input>
                                </el-form-item>
                                <!-- 父组织id -->
                                <el-form-item :label="columnInfo.parentId.label" prop="parentId">
                                  <select-tree v-model="queryParams.param.parentId" :options="[{id:'0',name:'根组织',childrenList:options.organizationOptions}]"
                                               :props="{value: 'id',label: 'name',children: 'childrenList'}" size="small"></select-tree>
                                </el-form-item>
<!--                                &lt;!&ndash; 祖级列表 &ndash;&gt;-->
<!--                                <el-form-item :label="columnInfo.ancestors.label" prop="ancestors">-->
<!--                                        <el-input v-model="queryParams.param.ancestors" placeholder="请输入内容" size="small" clearable></el-input>-->
<!--                                </el-form-item>-->
                                <!-- 层级 -->
                                <el-form-item :label="columnInfo.hierarchy.label" prop="hierarchy">
                                        <el-input v-model="queryParams.param.hierarchy" placeholder="请输入内容" size="small" clearable></el-input>
                                </el-form-item>
<!--                                &lt;!&ndash; 排序号 &ndash;&gt;-->
<!--                                <el-form-item :label="columnInfo.sort.label" prop="sort">-->
<!--                                        <el-input v-model="queryParams.param.sort" placeholder="请输入内容" size="small" clearable></el-input>-->
<!--                                </el-form-item>-->
                                <!-- 状态 0：无效 1：有效 -->
                                <el-form-item :label="columnInfo.state.label" prop="state">
                                      <enum-dict-select v-model="queryParams.param.state" dict-code="state" module-name="system" size="small"></enum-dict-select>
                                </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="small" @click="handleTableSearch">搜索</el-button>
                            <el-button icon="el-icon-refresh" size="small" @click="clickReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <!--右边中部功能区-->
                    <el-row :gutter="10" style="margin-bottom:13px;margin-right: 1px">
                        <el-col :span="1.5">
                            <el-button
                                    type="primary"
                                    plain
                                    icon="el-icon-plus"
                                    size="small"
                                    @click="clickAdd"
                                    v-permissionDisabled="'system:organization:create'"
                            >新增</el-button>
                        </el-col>
                        <el-col :span="1.5">
                            <excel-import-plus title="系统组织表	" module-name="system" table-name="organization" :permission-code="'system:organization:import'"></excel-import-plus>
                        </el-col>
                        <el-col :span="1.5">
                            <excel-export-plus file-name="系统组织表	" module-name="system" table-name="organization" :select-list="selectList" :permission-code="'system:organization:export'"></excel-export-plus>
                        </el-col>
                        <right-toolbar-plus :showSearch.sync="showSearch" @queryTable="handleTableSearch"
                                            :columnInfo="columnInfo" @redoTableLayout="redoTableLayout"></right-toolbar-plus>
                    </el-row>
                    <!--右边中部表格区-->
                    <div class="main">
                        <div class="table">
                            <el-table border row-key="id" :tree-props="{children: 'childrenList'}" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                                      @selection-change="handleSelectionChange" height="100%" :header-cell-style="{background:'#ECF5FF'}">
                                <el-table-column align="center" type="selection" width="55"/>
                                        <!-- 组织名 -->
                                        <af-table-column align="center" prop="name" :label="columnInfo.name.label" v-if="columnInfo.name.visible"></af-table-column>
                                        <!-- 组织代码 -->
                                        <af-table-column align="center" prop="code" :label="columnInfo.code.label" v-if="columnInfo.code.visible"></af-table-column>
<!--                                        &lt;!&ndash; 父组织id &ndash;&gt;-->
<!--                                        <af-table-column align="center" prop="parentId" :label="columnInfo.parentId.label" v-if="columnInfo.parentId.visible"></af-table-column>-->
<!--                                        &lt;!&ndash; 祖级列表 &ndash;&gt;-->
<!--                                        <af-table-column align="center" prop="ancestors" :label="columnInfo.ancestors.label" v-if="columnInfo.ancestors.visible"></af-table-column>-->
                                        <!-- 层级 -->
                                        <af-table-column align="center" prop="hierarchy" :label="columnInfo.hierarchy.label" v-if="columnInfo.hierarchy.visible"></af-table-column>
                                        <!-- 排序号 -->
                                        <af-table-column align="center" prop="sort" :label="columnInfo.sort.label" v-if="columnInfo.sort.visible"></af-table-column>
                                        <!-- 状态 -->
                                        <el-table-column align="center" prop="state" :label="columnInfo.state.label" v-if="columnInfo.state.visible">
                                          <template slot-scope="scope">
                                            <enum-dict-label v-model="scope.row.state" module-name="system" dict-code="state"
                                                             show-tag></enum-dict-label>
                                          </template>
                                        </el-table-column>
                                <!-- 操作列 -->
                                <el-table-column align="center" label="操作" width="245" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button @click="clickEdit(scope.row)" type="primary" size="mini" v-permissionDisabled="'system:organization:update'">编辑</el-button>
                                        <el-button @click="clickDel(scope.row)" type="danger" size="mini" v-permissionDisabled="'system:organization:remove'">删除</el-button>
                                        <table-more-button :row="scope.row" :button-props="moreButtonProps" @handleCommand="handleCommand"></table-more-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <!--右边底部分页区-->
                    <div style="height: 4px;margin-bottom: 0.1rem;">
<!--                        <pagination-plus :totalCount="totalCount"-->
<!--                                         :param="queryParams"-->
<!--                                         :pageSizes="pageSizes"-->
<!--                                         :selectList="selectList"-->
<!--                                         module-name="system"-->
<!--                                         table-name="organization"-->
<!--                                         :del-all-permission-code="'system:organization:removes'"-->
<!--                                         :state-permission-code="'system:organization:state'"-->
<!--                                         @handleTableRefresh="handleTableSearch"/>-->
                    </div>
                </el-col>
        </el-row>
        <!-- 弹出层组件 -->
        <OrganizationForm/>
    </div>
</template>

<script>
    /**
     * 系统组织表	主页面 （与自定义组件之间请遵循MVVM架构）
     * @author PeterLee
     * @since 2022-06-23
     */
    import OrganizationForm from "./OrganizationForm"
    import {mapState, mapMutations, mapActions} from "vuex";

    export default {
        components: {
            //表单弹出组件
            OrganizationForm
        },
        data() {
            return {
                //每页条数选项（分页控件）
                pageSizes: [10, 20, 40, 80],
                //批量操作选中list（分页控件）
                selectList: [],
                //展示搜索区（right-toolbar）
                showSearch: false,
                //导出loading
                exportLoading: false,
            }
        },
        computed: {
            ...mapState({
                //表格数据
                tableData: state => state.system.organization.tableData,
                //下拉选项
                options: state => state.system.organization.options,
                //共有数据条数（分页控件）
                totalCount: state => state.system.organization.totalCount,
                //列信息
                columnInfo: state => state.system.organization.columnInfo,
                //查询参数
                queryParams: state => state.system.organization.queryParams,
                //时间范围
                dateRange: state => state.system.organization.dateRange,
                //更多按钮信息
                moreButtonProps: state => state.system.organization.moreButtonProps,
            })
        },
        //生命周期create函数
        created() {
            //创建时获取所有权限数据（分页查询）
            this.handleTableSearch();
            //获取OptionList
            this.getOptionList();
        },
        methods: {
            ...mapMutations({
                clickEdit: 'system/organization/clickEdit',
                clickAdd: 'system/organization/clickAdd',
            }),
            ...mapActions({
                clickDel: 'system/organization/handleDel',
                handleTableSearch: 'system/organization/handleTableSearch',
                getOptionList: 'system/organization/getOptionList',
            }),
            /** 重置按钮点击（搜索区） */
            clickReset() {
                for (let key of Object.keys(this.dateRange)) {
                    this.dateRange[key] = []
                }
                this.$refs['queryForm'].resetFields();
                this.handleTableSearch();
            },
            /** 处理选择改变（表格区） */
            handleSelectionChange(selectList) {
                this.selectList = selectList;
            },
            /** 重新计算表格（按钮区） */
            redoTableLayout(){
                //数据加载完成后执行
                this.$nextTick(() => {
                    //表格重新渲染
                    this.$refs.multipleTable.doLayout();
                });
            },
            /** 更多按钮方法处理（按钮区） */
            handleCommand(command,row){
                // console.log(command)
                // console.log(row)
            }
        }
    }
</script>

<style lang="less" scoped>
    @import url('~@/assets/style/index.less');

    ::v-deep .el-form-item {
        margin-bottom: 18px;
    }
</style>
